// removed by extract-text-webpack-plugin
module.exports = {"info-display":"info-display","col-sm-3":"col-sm-3","class-info-display":"class-info-display","col-sm-9":"col-sm-9"};


//////////////////
// WEBPACK FOOTER
// ./src/template/InfoDisplays/InfoDisplay.scss
// module id = XM/K
// module chunks = 0